import http_config from '../../common/config/http_config';
import axiosInstance from '../../common/helper/axiosInterceptor';
import { CardModel } from './card.model';


export const onSetCard = (userId: string , payload: CardModel): Promise<CardModel> => {

  return axiosInstance.post(http_config.BASE_URL + '/card/' + userId , payload); 
};
